// extracted by mini-css-extract-plugin
export default {"ring":"LoadingRing_ring__nzSOx","small":"LoadingRing_small__lY1Ih","large":"LoadingRing_large__f1xlR"};